import basic from './basic';
import tsmTheme from './tcm';

export default {
  basic,
  tsmTheme,
};
